export default function CommandRail({
  diceVisible,
  setDiceVisible,
  imageVisible,
  setImageVisible,
  initiativeVisible,
  setInitiativeVisible,
  isRoomLocked,
  handleLockRoom,
  handleUnlockRoom,
  xCardActive,
  handleXCardPress,
  handleDisconnect,
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "10px" }}>
      {/* 🎲 Dice Toggle Button */}
      <button
        onClick={() => setDiceVisible((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          width: "40px",
          height: "100px",
          marginBottom: "10px",
          background: "linear-gradient(135deg, #3498db, #2ecc71)",
          border: "2px solid #1b6ca8",
          borderRadius: "8px",
          color: "white",
          cursor: "pointer",
          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
        }}
      >
        <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
          {diceVisible ? "Hide Table" : "Dice Table"}
        </span>
      </button>

      {/* 🖼️ Image table toggle button */}
      <button
        onClick={() => setImageVisible((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          width: "40px",
          height: "100px",
          marginBottom: "10px",
          background: "linear-gradient(10deg, #3B5A78, #1E1E1E)",
          border: "2px solid #3B5A78",
          borderRadius: "8px",
          color: "white",
          cursor: "pointer",
          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
        }}
      >
        <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
          {imageVisible ? "Hide Image" : "Image Table"}
        </span>
      </button>

      {/* 🧮 Initiative Tracker Toggle Button */}
      <button
        onClick={() => setInitiativeVisible((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          width: "40px",
          height: "100px",
          marginBottom: "10px",
          background: "linear-gradient(135deg, #8e44ad, #9b59b6)",
          border: "2px solid #5e3370",
          borderRadius: "8px",
          color: "white",
          cursor: "pointer",
          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
        }}
      >
        <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
          {initiativeVisible ? "Hide Init" : "Initiative"}
        </span>
      </button>

      {/* 🔐 Lock/Unlock Button */}
      {!isRoomLocked && (
        <button
          onClick={handleLockRoom}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
            width: "40px",
            height: "100px",
            marginBottom: "10px",
            background: "linear-gradient(135deg, #e74c3c, #c0392b)",
            border: "2px solid #922b21",
            borderRadius: "8px",
            color: "white",
            cursor: "pointer",
            boxShadow: "0 0 8px rgba(0,0,0,0.3)",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
            Lock Room
          </span>
        </button>
      )}

      {isRoomLocked && (
        <button
          onClick={handleUnlockRoom}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
            width: "40px",
            height: "100px",
            marginBottom: "10px",
            background: "linear-gradient(135deg, #f1c40f, #f39c12)",
            border: "2px solid #b9770e",
            borderRadius: "8px",
            color: "white",
            cursor: "pointer",
            boxShadow: "0 0 8px rgba(0,0,0,0.3)",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
            Unlock Room
          </span>
        </button>
      )}

      {/* 🧠 X Card Button */}
      <button
        onClick={handleXCardPress}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          width: "40px",
          height: "100px",
          marginBottom: "10px",
          background: xCardActive ? "red" : "linear-gradient(135deg, #2ecc71, #27ae60)",
          border: xCardActive ? "2px solid darkred" : "2px solid #1e8449",
          borderRadius: "8px",
          color: "white",
          cursor: "pointer",
          boxShadow: xCardActive ? "0 0 15px rgba(255,0,0,0.8)" : "0 0 8px rgba(0,0,0,0.3)",
          animation: xCardActive ? "flashRed 1s infinite" : "none",
        }}
      >
        <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
          🛑 X Card
        </span>
      </button>

      {/* 🔌 Disconnect Button */}
      <button
        onClick={handleDisconnect}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          width: "40px",
          height: "100px",
          marginBottom: "10px",
          background: "linear-gradient(135deg, #ffcc00, #ff6600)",
          border: "2px solid #cc5200",
          borderRadius: "8px",
          color: "white",
          cursor: "pointer",
          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
        }}
      >
        <span style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", fontSize: "14px" }}>
          Disconnect
        </span>
      </button>
    </div>
  );
}
